import AdditionalAddresses from './components/AdditionalAddresses'
import { withGlobal } from 'components/global/GlobalWrapper'
import { buildingStructuresReducers } from 'components/stores/building_structures/reducers'

export default withGlobal(AdditionalAddresses, { reducers: buildingStructuresReducers })
